import React from "react";

import { APP_SHELL } from "@/lib/constants/workspace-layout";
import { useTranslation } from "@/lib/hooks/use-translation";
import { LOCALES, type Locale } from "@/lib/i18n/types";
import { cn } from "@/lib/utils";

export function LanguageSwitcher() {
  const { locale, setLocale, t } = useTranslation();

  return (
    <div
      className={APP_SHELL.languageSwitcherOuter}
      role="group"
      aria-label={t("header.language")}
      data-testid="language-switcher"
    >
      {LOCALES.map((entry) => (
        <button
          key={entry}
          type="button"
          className={cn(
            "rounded-md px-2 py-1 text-xs font-semibold uppercase tracking-wide transition-colors",
            locale === entry ? APP_SHELL.languageSwitcherActive : APP_SHELL.languageSwitcherInactive,
          )}
          aria-pressed={locale === entry}
          data-testid={`language-switcher-${entry}`}
          onClick={() => setLocale(entry as Locale)}
        >
          {entry}
        </button>
      ))}
    </div>
  );
}
